import { render, staticRenderFns } from "./ValidMarcacoes.vue?vue&type=template&id=4e2f970e&"
import script from "./ValidMarcacoes.vue?vue&type=script&lang=js&"
export * from "./ValidMarcacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports